import { Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { DetailProductComponent } from './components/cart/detail-product/detail-product.component';
import { SumaryOrderComponent } from './components/orders/sumary-order/sumary-order.component';
import { PaymentSuccessComponent } from './components/payment-success/payment-success.component';
import { LogoutComponent } from './components/logout/logout.component';
import { authGuard } from './guards/auth.guard';
import { OrderHistoryComponent } from './components/orders/order-history/order-history.component';
import { AdaptiveMainLayoutComponent } from './components/layout/adaptive-main-layout/adaptive-main-layout.component';
import { TermsConditionsComponent } from './components/legal/terms-conditions.component';
import { PrivacyPolicyComponent } from './components/legal/privacy-policy.component';
import { WarrantyReturnsComponent } from './components/legal/warranty-returns.component';
import { TrademarkNoticeComponent } from './components/legal/trademark-notice.component';

export const routes: Routes = [
    // Rutas de Admin (Lazy Loaded) - Fuera del layout principal
    {
        path: 'admin',
        loadChildren: () => import('./components/admin/admin.routes').then(m => m.ADMIN_ROUTES)
    },

    // Rutas de Autenticación (Lazy Loaded) - Fuera del layout principal
    {
        path: 'user',
        loadChildren: () => import('./components/authetication/auth.routes').then(m => m.AUTH_ROUTES)
    },

    // Rutas públicas y de usuario con Layout Principal
    {
        path: '',
        component: AdaptiveMainLayoutComponent,
        children: [
            {path:'', component:HomeComponent, data: { animation: 'HomePage', depth: 1 }},
            {
                path: 'tienda',
                loadChildren: () => import('./shop/shop.routes').then(m => m.SHOP_ROUTES),
                data: { animation: 'ShopPage', depth: 2 }
            },
            {path: 'producto/:id', component:DetailProductComponent, data: { animation: 'ProductPage', depth: 3 }},
            {path: 'cart/sumary', component:SumaryOrderComponent, data: { animation: 'CartPage', depth: 2 }},
            {path: 'payment-success', component:PaymentSuccessComponent, data: { animation: 'PaymentSuccessPage', depth: 3 }},
            {path: 'payment-error', component:PaymentSuccessComponent, data: { animation: 'PaymentErrorPage', depth: 3 }},
            {path: 'order-history', component: OrderHistoryComponent, canActivate: [authGuard], data: { animation: 'OrderHistoryPage', depth: 2, requiredRole: 'USER' }},
            {path: 'terminos', component: TermsConditionsComponent, data: { animation: 'TermsPage', depth: 2 }},
            {path: 'privacidad', component: PrivacyPolicyComponent, data: { animation: 'PrivacyPage', depth: 2 }},
            {path: 'garantias-retracto', component: WarrantyReturnsComponent, data: { animation: 'WarrantyPage', depth: 2 }},
            {path: 'aviso-legal', component: TrademarkNoticeComponent, data: { animation: 'TrademarkPage', depth: 2 }},
            {path: 'logout', component: LogoutComponent, data: { animation: 'LogoutPage', depth: 1 }}
        ]
    }
];

